import { InjectionToken } from '@angular/core';

export const REGISTRATION_CONFIG = new InjectionToken<ApplicationRegistrationConfigurationProperties>(
  'registration.applicationConfig',
);

export interface ApplicationRegistrationConfigurationProperties {
  showMembersVerifiedLabels: boolean;
}
